<div class="card title-card mb-4">
  <div class="flex align-items-center">
    <i class="pi mr-1 title-card-icon" [class.pi-plus-circle]="mode === 'create'" [class.pi-pencil]="mode === 'edit'"></i>
    <p class="mb-0 text-3xl title">
      {{(mode == 'create' ? 'misc.creation.encoder' : 'misc.edition.encoder') | transloco | capitalize}}
    </p>
  </div>
</div>
<div class="card step-card flex flex-column">
  <form [formGroup]="encoderForm" *ngIf="encoderForm">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="name">{{'attribute.name' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="name" type="text" formControlName="name" class="w-full">
        </div>
        <app-validation-errors [control]="encoderForm.get('name')"></app-validation-errors>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="tenant">{{'model.tenant' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.tenant' | transloco"
            [options]="tenants"
            [filter]="true"
            styleClass="w-full"
            id="tenant"
            optionLabel="name"
            formControlName="tenant"
          ></p-dropdown>
        </div>
      </div>

      <div class="col-12">
        <div class="form-field col-12">
          <label for="tenant">{{'attribute.commandsSchema' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <json-editor
            #commandsSchemaEditor
            [options]="jsonEditorService.buildFormEditorOptions()"
            formControlName="commandsSchema"
          ></json-editor>
        </div>
      </div>

    </div>
  </form>
  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <button
        [label]="'common.cancel' | transloco"
        [routerLink]="'/system/encoders'"
        pButton
        class="p-button-danger"
        iconPos="right"
      ></button>
      <p-button
        *ngIf="encoderForm"
        [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
        [disabled]="!encoderForm.valid"
        [loading]="persistingChanges"
        (onClick)="persistEncoderData()"
        styleClass="p-button-primary"
        class="mr-2"
      ></p-button>
    </div>
  </div>
</div>
